import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "antd/dist/antd.css";
import "antd/dist/antd.less";
import "./styles.scss";
import App from "app/App";
import store from "app/store";
import history from "utilities/history";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
);
